import React, { Component } from "react";
import DataContainer from "../containers/DataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import PURCHASEIRQNotSupportedView from "../views/IrqNotSupportedView";
import { object } from "yup";
import EditableDataContainer from "../containers/EditableDataContainer";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqNotSupportedPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol +
      ApiConfig.apiUri +
      ApiConfig.irqEndpoint +
      this.props.params.id;

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="buildIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object()}
        >
          <PURCHASEIRQNotSupportedView
            content={contentMap.RefinanceIrqNotSupportedPage}
            navigationsAway={customNavigationMap.RefinanceIrqNotSupportedPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqNotSupportedPage);
